/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global snackbar, lng, URL, Promise, schema, schema, Network, CONTENT_TARGET, eyes, RestEdit, FormExportCsvBuilder */

function AutomaticExport() {
  if (!this instanceof AutomaticExport) return new AutomaticExport();

  const that = this;

  /**
   * @type Element
   */
  this.node = document.createElement("div");

  /**
   * Will be called when user close the view.
   * Only if form is valid.
   * @param {string} json
   * Result from <i>FormBuilder.getJson()</i>
   * @returns {undefined}
   */
  this.onclose = (json) => console.warn("onclose() should be overwriten");
  this.oncancel = () => console.warn("oncancel() should be overwriten");

  /**
   * Build some stuff by this json
   * @param {string} json
   */
  this.loadJson = function (json) {
    const xhr = new XMLHttpRequest();
    const that = this;
    xhr.open("GET", "content/exports.html", true);
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status !== 200) return;

      that.node.classList.add("export-builder");
      that.node.insertAdjacentHTML("beforeend", this.responseText);

      that.smtpModal = new SMTPModal(that.node);
      that.smtpModal.loadJson(json);

      that.ftpModal = new FTPModal(that.node);
      that.ftpModal.loadJson(json);

      that.dateModal = new DateModal(that);
      that.dateModal.loadJson(json);

      that.exportSavings = new AutomaticExportSaving(that);

      that.initHandlers(json);
    };
    xhr.send();
  };

  /**
   * Fill the input- and select-fields with the JSON-data
   * @param json
   */
  this.setJSONData = function (json) {
    let exportNameInput = this.node.querySelector('input[name="exportname"]');
    exportNameInput.value = json.name;

    let exportFilenameInput = this.node.querySelector(
      'input[name="exportfilename"]'
    );
    exportFilenameInput.value = json.filename;

    let zipPasswordInput = this.node.querySelector('input[name="zippassword"]');
    zipPasswordInput.value = json.zipPassword;

    const weekdays = json.dateConfig.weekdays.filter(
      (weekday) => weekday.active === true
    );
    const nextExportSpan = this.node.querySelector(".next-export");

    const printCheckbox = this.node.querySelector(".print-epaper .print");
    const epaperCheckbox = this.node.querySelector(".print-epaper .epaper");
    const withoutCheckbox = this.node.querySelector(
      ".print-epaper .without-selection"
    );

    if (json.exportConfig) {
      epaperCheckbox.checked = json.exportConfig.epaper;
      printCheckbox.checked = json.exportConfig.print;
      withoutCheckbox.checked = json.exportConfig.without;
    }

    function handlePrintEpaperCheckbox(checkbox) {
      if (checkbox.checked) {
        withoutCheckbox.checked = false;
        withoutCheckbox.disabled = true;
      } else {
        withoutCheckbox.disabled = false;
      }
    }

    printCheckbox.addEventListener("change", () => {
      handlePrintEpaperCheckbox(printCheckbox);
    });

    epaperCheckbox.addEventListener("change", () => {
      handlePrintEpaperCheckbox(epaperCheckbox);
    });

    withoutCheckbox.addEventListener("change", () => {
      if (withoutCheckbox.checked) {
        epaperCheckbox.checked = false;
        printCheckbox.checked = false;
        epaperCheckbox.disabled = true;
        printCheckbox.disabled = true;
      } else {
        epaperCheckbox.disabled = false;
        printCheckbox.disabled = false;
      }
    });

    const singleUploadCheckbox = this.node.querySelector(
      ".single-upload-checkbox"
    );
    singleUploadCheckbox.checked = json.singleUpload;

    const excelCheckbox = this.node.querySelector(".excel-export");
    excelCheckbox.checked = json.exportAsExcel;

    if (weekdays.length === 0) {
      nextExportSpan.textContent = "Keine Exporttage aktiv";
    } else {
      let nextExport = null;
      weekdays.map((weekday) => {
        // Find the next active export-day
        let nextExportDate = null;
        if (!weekday.nextExport) {
          const weekDayToFind = moment()
            .day(getGermanWeekday(weekday.weekday))
            .weekday();
          const searchDate = moment();
          while (
            searchDate.weekday() !== weekDayToFind ||
            searchDate.isSame(moment(), "day")
          ) {
            searchDate.add(1, "day");
          }

          nextExportDate = searchDate;
        } else {
          nextExportDate = moment(weekday.nextExport);
        }

        if (!nextExport || nextExportDate < nextExport) {
          nextExport = nextExportDate;
        }
      });
      if (nextExport)
        nextExportSpan.textContent = `Nächster Export: ${nextExport.format(
          "dddd DD.MM.YYYY"
        )}`;
    }

    if (!json.active) {
      nextExportSpan.textContent = `Der Export ist derzeit inaktiv!`;
    }
  };

  /**
   * Update all the handlers for each select-field (or input)
   * @param json
   */
  this.initHandlers = function (json) {
    this.json = json;
    this.setJSONData(json.data);

    let exportNameInput = this.node.querySelector('input[name="exportname"]');
    this.exportNameInput = exportNameInput;

    let exportFilenameInput = this.node.querySelector(
      'input[name="exportfilename"]'
    );
    this.exportFilenameInput = exportFilenameInput;

    let zipPasswordInput = this.node.querySelector('input[name="zippassword"]');
    this.zipPasswordInput = zipPasswordInput;

    const printCheckbox = this.node.querySelector(".print-epaper .print");
    const epaperCheckbox = this.node.querySelector(".print-epaper .epaper");
    const withoutCheckbox = this.node.querySelector(
      ".print-epaper .without-selection"
    );
    const excelCheckbox = this.node.querySelector(".excel-export");
    const singleUploadCheckbox = this.node.querySelector(
      ".single-upload-checkbox"
    );

    this.printCheckbox = printCheckbox;
    this.epaperCheckbox = epaperCheckbox;
    this.excelCheckbox = excelCheckbox;
    this.withoutCheckbox = withoutCheckbox;
    this.singleUploadCheckbox = singleUploadCheckbox;

    const partnergroupSelect = this.node.querySelector(`.partnerGroup select`);
    const locationSelect = this.node.querySelector(`.location select`);
    const employeeSelect = this.node.querySelector(`.employee select`);
    const formSelect = this.node.querySelector(`.form select`);
    const partnerSelect = this.node.querySelector(`.partner select`);

    const formActiveInput = this.node.querySelector(".form input");
    const locationActiveInput = this.node.querySelector(".location input");
    const employeeActiveInput = this.node.querySelector(".employee input");
    const formExportCSV = this.node.querySelector(".formExportCsv select");
    const formExportPDF = this.node.querySelector(".formExportPdf select");
    const formExportXML = this.node.querySelector(".formExportXml select");

    const saveButton = this.node.querySelector(".save-button");
    const cancelButton = this.node.querySelector(".cancel-button");

    this.partnergroupSelect = partnergroupSelect;
    this.locationSelect = locationSelect;
    this.employeeSelect = employeeSelect;
    this.formSelect = formSelect;
    this.partnerSelect = partnerSelect;
    this.formActiveInput = formActiveInput;
    this.locationActiveInput = locationActiveInput;
    this.employeeActiveInput = employeeActiveInput;
    this.formExportCSV = formExportCSV;
    this.formExportPDF = formExportPDF;
    this.formExportXML = formExportXML;

    this.saveButton = saveButton;
    this.cancelButton = cancelButton;

    this.updateSelectWidth(this.formExportCSV, "Keinen Export ausgewählt");
    this.updateSelectWidth(this.formExportPDF, "Keinen Export ausgewählt");
    this.updateSelectWidth(this.formExportXML, "Keinen Export ausgewählt");

    this.saveButton.addEventListener("click", () => {
      if (this.exportSavings.checkParams()) {
        this.exportSavings.saveParams();
      }
    });

    this.cancelButton.addEventListener("click", () => {
      this.node.parentNode.removeChild(that.node);
      this.oncancel();
    });

    this.partnergroupSelect.addEventListener("change", () => {
      const selectedPartnerGroup =
        this.partnergroupSelect.options[this.partnergroupSelect.selectedIndex]
          .data;
      this.selectedPartnerGroup = selectedPartnerGroup;

      this.updatePartnerSelect();

      this.clearFilterSelect(this.formExportCSV);
      this.clearFilterSelect(this.formExportPDF);
      this.clearFilterSelect(this.formExportXML);

      this.updateSelectWidth(this.formExportCSV, "Keinen Export ausgewählt");
      this.updateSelectWidth(this.formExportPDF, "Keinen Export ausgewählt");
      this.updateSelectWidth(this.formExportXML, "Keinen Export ausgewählt");

      this.updateSelectWidth(this.partnergroupSelect, "Bitte wählen");
    });

    this.partnerSelect.addEventListener("change", () => {
      const selectedPartner =
        this.partnerSelect.options[this.partnerSelect.selectedIndex].data;
      this.selectedPartner = selectedPartner;

      this.updateFormSelect();
      this.updateLocationSelect();
      this.updateEmployeeSelect();
      this.clearFilterSelect(this.formExportCSV);
      this.clearFilterSelect(this.formExportPDF);
      this.clearFilterSelect(this.formExportXML);

      this.updateSelectWidth(this.formExportCSV, "Keinen Export ausgewählt");
      this.updateSelectWidth(this.formExportPDF, "Keinen Export ausgewählt");
      this.updateSelectWidth(this.formExportXML, "Keinen Export ausgewählt");

      this.updateSelectWidth(this.locationSelect, "Alle");
      this.updateSelectWidth(this.employeeSelect, "Alle");

      this.updateSelectWidth(this.partnerSelect, "Bitte wählen");
      this.updateSelectWidth(this.formSelect, "Bitte wählen");
    });

    this.formSelect.addEventListener("change", () => {
      const selectedForm =
        this.formSelect.options[this.formSelect.selectedIndex].data.form;
      this.selectedForm = selectedForm;

      this.updateExportSelects();
      this.updateSelectWidth(this.formSelect, "Alle");
    });

    this.formActiveInput.addEventListener("change", () => {
      this.updateFormSelect();
    });

    this.employeeSelect.addEventListener("change", () => {
      const selectedEmployee =
        this.employeeSelect.options[this.employeeSelect.selectedIndex].data;
      this.selectedEmployee = selectedEmployee;

      this.updateSelectWidth(this.employeeSelect, "Alle");
    });

    this.employeeActiveInput.addEventListener("change", () => {
      this.updateEmployeeSelect();
    });

    this.locationSelect.addEventListener("change", () => {
      const selectedLocation =
        this.locationSelect.options[this.locationSelect.selectedIndex].data;
      this.selectedLocation = selectedLocation;

      this.updateSelectWidth(this.locationSelect, "Alle");
    });

    this.locationActiveInput.addEventListener("change", () => {
      this.updateLocationSelect();
    });

    this.formExportCSV.addEventListener("change", () => {
      if (this.formExportCSV.selectedIndex > 0) {
        const selectedCSVExport =
          this.formExportCSV.options[this.formExportCSV.selectedIndex].data;
        this.selectedCSVExport = selectedCSVExport;
      } else {
        this.selectedCSVExport = null;
      }

      this.updateSelectWidth(this.formExportCSV, "Keinen Export ausgewählt");
    });

    this.formExportPDF.addEventListener("change", () => {
      if (this.formExportPDF.selectedIndex > 0) {
        const selectedPDFExport =
          this.formExportPDF.options[this.formExportPDF.selectedIndex].data;
        this.selectedPDFExport = selectedPDFExport;
      } else {
        this.selectedPDFExport = null;
      }

      this.updateSelectWidth(this.formExportPDF, "Keinen Export ausgewählt");
    });

    this.formExportXML.addEventListener("change", () => {
      if (this.formExportXML.selectedIndex > 0) {
        const selectedXMLExport =
          this.formExportXML.options[this.formExportXML.selectedIndex].data;
        this.selectedXMLExport = selectedXMLExport;
      } else {
        this.selectedXMLExport = null;
      }

      this.updateSelectWidth(this.formExportXML, "Keinen Export ausgewählt");
    });

    this.updatePartnerGroupSelect();
  };

  /**
   * Calculate the width of the select-element
   * @param select
   * @param text
   */
  this.updateSelectWidth = function (select, text) {
    if (
      select.selectedIndex === 0 &&
      select.options[select.selectedIndex].innerHTML === text
    ) {
      if (10 + text.length * 8 < 120) {
        select.style.width = "120px";
      } else {
        select.style.width = 10 + text.length * 8 + "px";
      }
    } else {
      let formText = select.options[select.selectedIndex].data.name;

      if (!formText) {
        formText = select.options[select.selectedIndex].innerHTML;
      }

      select.style.width = 10 + formText.length * 8 + "px";
    }
  };

  /**
   * Reset the select-element
   * @param select
   */
  this.clearFilterSelect = function (select) {
    select.selectedIndex = 0;
    select.data = 0;
    Array.from(select.children)
      .filter((option) => option.data)
      .forEach((option) => select.removeChild(option));
  };

  /**
   * Load all available partnerGroups and add them to the select
   */
  this.updatePartnerGroupSelect = function () {
    this.selectedPartnerGroup = null;

    restCollection.partnerGroup.find(null).then((partnerGroups) => {
      partnerGroups = partnerGroups.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      let partnerGroupID = null;
      let selectedIndex = -1;
      if (this.json.data && this.json.data.partner.partnerGroup) {
        partnerGroupID = this.json.data.partner.partnerGroup;
      }

      const options = partnerGroups.map((pg, index) => {
        const option = document.createElement("option");
        option.textContent = pg.name;
        option.data = pg;

        if (partnerGroupID && partnerGroupID === pg.id) {
          selectedIndex = index + 1;
        }

        return option;
      });
      this.clearFilterSelect(this.partnergroupSelect);
      options.map((o) => this.partnergroupSelect.appendChild(o));

      this.updateSelectWidth(this.partnergroupSelect, "Bitte wählen");
      this.updateSelectWidth(this.partnerSelect, "Bitte wählen");
      this.updateSelectWidth(this.formSelect, "Bitte wählen");
      this.updateSelectWidth(this.locationSelect, "Alle");
      this.updateSelectWidth(this.employeeSelect, "Alle");

      this.partnergroupSelect.disabled = true;

      if (selectedIndex >= 0) {
        this.partnergroupSelect.selectedIndex = selectedIndex;
        const event = new Event("change");
        this.partnergroupSelect.dispatchEvent(event);
      }
    });
  };

  /**
   * Load all available partners and add them to the select
   */
  this.updatePartnerSelect = function () {
    let partnerGroupSelect = this.partnergroupSelect;
    let partnerGroupID;

    if (
      partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data &&
      partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data.id
    ) {
      partnerGroupID =
        partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data.id;
    }

    if (!partnerGroupID) {
      return;
    }

    // reset a lot of values because of the partner change
    this.selectedPartner = null;
    this.selectedEmployee = null;
    this.selectedLocation = null;
    this.selectedForm = null;
    this.selectedCSVExport = null;
    this.selectedPDFExport = null;

    const partnerQuery = {
      partnerGroup: partnerGroupID,
    };

    this.formActiveInput.disabled = true;

    restCollection.partner
      .find({
        where: partnerQuery,
      })
      .then((partners) => {
        partners = partners.sort((a, b) => a.name.localeCompare(b.name));

        let selectedIndex = -1;
        let partnerId = null;

        if (this.json.data && this.json.data.partner.id) {
          // Find the currently select partner
          partnerId = this.json.data.partner.id;
        }

        const options = partners.map((p, index) => {
          const option = document.createElement("option");
          option.textContent = p.name;
          option.data = p;

          if (partnerId && partnerId === p.id) {
            selectedIndex = index + 1;
          }

          return option;
        });

        this.clearFilterSelect(this.partnerSelect);
        options.map((o) => this.partnerSelect.appendChild(o));

        this.clearFilterSelect(this.locationSelect);
        this.clearFilterSelect(this.employeeSelect);
        this.clearFilterSelect(this.formSelect);

        this.updateSelectWidth(this.partnerSelect, "Bitte wählen");
        this.updateSelectWidth(this.formSelect, "Bitte wählen");

        this.partnerSelect.disabled = true;

        if (selectedIndex >= 0) {
          this.partnerSelect.selectedIndex = selectedIndex;
          const event = new Event("change");
          this.partnerSelect.dispatchEvent(event);
        }
      });
  };

  /**
   * Load all available forms and add them to the select
   */
  this.updateFormSelect = function () {
    let partnerSelect = this.partnerSelect;
    let partnerID;

    if (
      partnerSelect.options[partnerSelect.selectedIndex].data &&
      partnerSelect.options[partnerSelect.selectedIndex].data.id
    ) {
      partnerID = partnerSelect.options[partnerSelect.selectedIndex].data.id;
    }

    this.selectedForm = null;
    this.selectedPDFExport = null;
    this.selectedCSVExport = null;

    this.formActiveInput.disabled = false;
    this.updateSelectWidth(partnerSelect, "Bitte wählen");

    //load forms
    restCollection.formPartner
      .find({
        where: { partner: partnerID },
        populate: "form",
      })
      .then((formPartners) => {
        let selectedIndex = -1;
        let formId = null;

        if (
          this.json.data &&
          this.json.data.exportConfig &&
          this.json.data.exportConfig.form
        ) {
          formId = this.json.data.exportConfig.form.id;
        }

        const options = [];
        const forms = [];
        formPartners
          .filter((fp) => fp.form && fp.form.productive)
          .forEach((fp, index) => {
            const option = document.createElement("option");
            option.textContent = fp.form.name + " v" + fp.form.version;
            option.data = fp;

            if (!this.formActiveInput.checked) {
              options.push(option);
              forms.push(fp.form);
            } else if (this.formActiveInput.checked && fp.form.active) {
              options.push(option);
              forms.push(fp.form);
            }
          });
        this.forms = forms;

        this.forms.map((form, index) => {
          if (formId && formId === form.id) {
            selectedIndex = index + 1;
          }
        });

        this.formSelect.data = null;
        requestAnimationFrame(() => {
          this.clearFilterSelect(this.formSelect);
          options.map((o) => this.formSelect.appendChild(o));

          if (selectedIndex >= 0) {
            this.formSelect.selectedIndex = selectedIndex;
            const event = new Event("change");
            this.formSelect.dispatchEvent(event);
          }
        });

        this.updateSelectWidth(this.formSelect, "Bitte wählen");
      });
  };

  /**
   * Load all available locations and add them to the select
   */
  this.updateLocationSelect = function () {
    let partnerSelect = this.partnerSelect;
    let partnerID;

    if (
      partnerSelect.options[partnerSelect.selectedIndex].data &&
      partnerSelect.options[partnerSelect.selectedIndex].data.id
    ) {
      partnerID = partnerSelect.options[partnerSelect.selectedIndex].data.id;
    }

    this.selectedLocation = null;

    //load locations
    restCollection.locationPartner
      .find({
        where: { partner: partnerID },
        populate: "location",
      })
      .then((locationPartners) => {
        let selectedIndex = -1;
        let locationId = null;

        if (
          this.json.data &&
          this.json.data.exportConfig &&
          this.json.data.exportConfig.location
        ) {
          locationId = this.json.data.exportConfig.location.id;
        }

        const options = [];
        locationPartners = locationPartners.sort((a, b) =>
          a.location.name.localeCompare(b.location.name)
        );
        locationPartners.map((lp) => {
          if (this.locationActiveInput.checked && !lp.active) {
            return;
          }

          const option = document.createElement("option");
          if (lp.location.adress) {
            option.textContent =
              lp.location.name + " (" + lp.location.adress + ")";
          } else {
            option.textContent = lp.location.name;
          }

          option.data = lp.location;
          options.push(option);

          if (lp.location.id === locationId) {
            selectedIndex = options.length;
          }
        });

        this.locationSelect.data = null;
        requestAnimationFrame(() => {
          this.clearFilterSelect(this.locationSelect);
          options.map((o) => this.locationSelect.appendChild(o));

          if (selectedIndex >= 0) {
            this.locationSelect.selectedIndex = selectedIndex;
            const event = new Event("change");
            this.locationSelect.dispatchEvent(event);
          }
        });

        this.updateSelectWidth(this.locationSelect, "Alle");
      });
  };

  /**
   * Load all available employees (promoters) and add them to the select
   */
  this.updateEmployeeSelect = function () {
    let partnerSelect = this.partnerSelect;
    let partnerID;

    if (
      partnerSelect.options[partnerSelect.selectedIndex].data &&
      partnerSelect.options[partnerSelect.selectedIndex].data.id
    ) {
      partnerID = partnerSelect.options[partnerSelect.selectedIndex].data.id;
    }

    this.selectedEmployee = null;

    //load employees
    restCollection.employeePartner
      .find({
        where: { partner: partnerID },
        populate: "employee",
      })
      .then((employeePartners) => {
        let selectedIndex = -1;
        let employeeId = null;

        if (
          this.json.data &&
          this.json.data.exportConfig &&
          this.json.data.exportConfig.employee
        ) {
          employeeId = this.json.data.exportConfig.employee.id;
        }

        employeePartners = employeePartners.sort((a, b) =>
          a.employee.name.localeCompare(b.employee.name)
        );

        const options = [];
        employeePartners.map((ep) => {
          if (this.employeeActiveInput.checked && !ep.active) {
            return;
          }

          const option = document.createElement("option");
          option.textContent = ep.employee.name;
          option.data = ep.employee;
          options.push(option);

          if (ep.employee.id === employeeId) {
            selectedIndex = options.length;
          }
        });

        this.employeeSelect.data = null;
        requestAnimationFrame(() => {
          this.clearFilterSelect(this.employeeSelect);
          options.map((o) => this.employeeSelect.appendChild(o));

          if (selectedIndex >= 0) {
            this.employeeSelect.selectedIndex = selectedIndex;
            const event = new Event("change");
            this.employeeSelect.dispatchEvent(event);
          }
        });

        this.updateSelectWidth(this.employeeSelect, "Alle");
      });
  };

  /**
   * Load all available export-settings (CSV, PDF, XML) for the current form
   */
  this.updateExportSelects = function () {
    const form = this.selectedForm;
    const formID = form.id;

    this.updateSelectWidth(this.formSelect, "Bitte wählen");

    this.selectedCSVExport = null;
    this.selectedPDFExport = null;
    this.selectedXMLExport = null;

    const formSchema = JSON.parse(form.schema);
    let foundPrint = false;
    formSchema.forEach((d) => {
      if (d.type === "address" && d.meta.epaper) {
        foundPrint = true;
      }
    });

    const checkboxes = this.node.querySelectorAll(".print-epaper .checkbox");
    for (let i = 0; i < checkboxes.length; ++i) {
      checkboxes[i].disabled = !foundPrint;
    }

    this.formExportCSV.selectedIndex = 0;
    this.formExportCSV.data = 0;
    Array.from(this.formExportCSV.children).forEach((option) =>
      this.formExportCSV.removeChild(option)
    );

    this.formExportPDF.selectedIndex = 0;
    this.formExportPDF.data = 0;
    Array.from(this.formExportPDF.children).forEach((option) =>
      this.formExportPDF.removeChild(option)
    );

    this.formExportXML.selectedIndex = 0;
    this.formExportXML.data = 0;
    Array.from(this.formExportXML.children).forEach((option) =>
      this.formExportXML.removeChild(option)
    );

    //load formExportCsv
    restCollection.formExportCsv
      .find({
        where: { form: formID },
      })
      .then((forms) => {
        let selectedIndex = -1;
        let csvId = null;

        if (this.json.data && this.json.data.csvConfig) {
          csvId = this.json.data.csvConfig.id;
        }

        const options = [];
        const defaultOption = document.createElement("option");
        defaultOption.textContent = "Keinen Export ausgewählt";
        defaultOption.data = null;
        options.push(defaultOption);

        forms.map((f, index) => {
          const option = document.createElement("option");
          option.textContent = f.name;
          option.data = f;
          options.push(option);

          if (f.id === csvId) {
            selectedIndex = index + 1;
          }
        });
        const select = this.node.querySelector(`.formExportCsv select`);
        select.data = null;
        requestAnimationFrame(() => {
          this.clearFilterSelect(select);
          options.map((o) => select.appendChild(o));
          this.updateSelectWidth(
            this.formExportCSV,
            "Keinen Export ausgewählt"
          );

          if (selectedIndex >= 0) {
            select.selectedIndex = selectedIndex;
            const event = new Event("change");
            select.dispatchEvent(event);
          }
        });
      });

    //load formExportPdf
    restCollection.formExportPdf
      .find({
        where: { form: formID },
      })
      .then((forms) => {
        let selectedIndex = -1;
        let pdfId = null;

        if (this.json.data && this.json.data.pdfConfig) {
          pdfId = this.json.data.pdfConfig.id;
        }

        const options = [];
        const defaultOption = document.createElement("option");
        defaultOption.textContent = "Keinen Export ausgewählt";
        defaultOption.data = null;
        options.push(defaultOption);

        forms.map((f, index) => {
          const option = document.createElement("option");
          option.textContent = f.name;
          option.data = f;
          options.push(option);

          if (f.id === pdfId) {
            selectedIndex = index + 1;
          }
        });
        const select = this.node.querySelector(`.formExportPdf select`);
        select.data = null;
        requestAnimationFrame(() => {
          this.clearFilterSelect(select);
          options.map((o) => select.appendChild(o));
          this.updateSelectWidth(
            this.formExportPDF,
            "Keinen Export ausgewählt"
          );

          if (selectedIndex >= 0) {
            select.selectedIndex = selectedIndex;
            const event = new Event("change");
            select.dispatchEvent(event);
          }
        });
      });

    //load formExportXml
    restCollection.formExportXml
      .find({
        where: { form: formID },
      })
      .then((forms) => {
        let selectedIndex = -1;
        let xmlId = null;

        if (this.json.data && this.json.data.xmlConfig) {
          xmlId = this.json.data.xmlConfig.id;
        }

        const options = [];
        const defaultOption = document.createElement("option");
        defaultOption.textContent = "Keinen Export ausgewählt";
        defaultOption.data = null;
        options.push(defaultOption);

        forms.map((f, index) => {
          const option = document.createElement("option");
          option.textContent = f.name;
          option.data = f;
          options.push(option);

          if (f.id === xmlId) {
            selectedIndex = index + 1;
          }
        });
        const select = this.node.querySelector(`.formExportXml select`);
        select.data = null;
        requestAnimationFrame(() => {
          this.clearFilterSelect(select);
          options.map((o) => select.appendChild(o));
          this.updateSelectWidth(
            this.formExportXML,
            "Keinen Export ausgewählt"
          );

          if (selectedIndex >= 0) {
            select.selectedIndex = selectedIndex;
            const event = new Event("change");
            select.dispatchEvent(event);
          }
        });
      });
  };
}
